export default function Bubble({ icon, label, subtext, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        flex: '1 1 0',
        maxWidth: 180,
      }}
    >
      <div
        style={{
          width: 'clamp(92px, 22vw, 118px)',
          height: 'clamp(92px, 22vw, 118px)',
          borderRadius: '50%',
          background: '#FAF6EC',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: `
            0 10px 24px rgba(120,90,30,0.18),
            0 2px 6px rgba(120,90,30,0.10),
            inset 0 -4px 10px rgba(184,137,58,0.10),
            inset 0 4px 8px rgba(255,255,255,0.8)
          `,
          transition: 'transform 0.18s, box-shadow 0.18s',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = `
            0 16px 32px rgba(120,90,30,0.22),
            0 4px 10px rgba(120,90,30,0.12),
            inset 0 -4px 10px rgba(184,137,58,0.10),
            inset 0 4px 8px rgba(255,255,255,0.8)
          `;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = `
            0 10px 24px rgba(120,90,30,0.18),
            0 2px 6px rgba(120,90,30,0.10),
            inset 0 -4px 10px rgba(184,137,58,0.10),
            inset 0 4px 8px rgba(255,255,255,0.8)
          `;
        }}
      >
        {icon}
      </div>
      <div
        style={{
          fontFamily: "'DM Serif Display', serif",
          fontSize: 'clamp(14px, 3.4vw, 17px)',
          color: '#2C2C2C',
          lineHeight: 1.2,
          whiteSpace: 'pre-line',
          textAlign: 'center',
        }}
      >
        {label}
      </div>
      {subtext && (
        <div
          style={{
            fontSize: 'clamp(11px, 2.6vw, 12.5px)',
            color: '#6B6358',
            lineHeight: 1.4,
            textAlign: 'center',
            padding: '0 4px',
            maxWidth: 160,
          }}
        >
          {subtext}
        </div>
      )}
    </button>
  );
}
